import {ApiService} from "./api.service";

export class DonationService extends ApiService{
  constructor(organizationId) {
    super();
    // this.endpoint = "/donations";
    this.endpoint = `/organizations/${organizationId}/donations`;
    this.per = 10;
  }

  async initDonationIntent(params){
    try {
      let url = `${this.endpoint}/donation_intent`;
      let response = await this.post(url, params);
      if (response.status === 422 && response.json?.alert) {
        return { error: response.json.alert };
      }
      return response.json;
    } catch {
      return {"error": "error loading donation form"};
    }
  }

  async confirmPayment(params){
    try {
      let url = `${this.endpoint}/finalize`;
      let response = await this.post(url, params);
      return response.json;
    } catch {
      return null;
    }
  }
  async offlineDonation(params){
    try {
      let url = `${this.endpoint}/offline`;
      let response = await this.post(url, params);
      return response.json;
    } catch {
      return null;
    }
  }

  async searchDonors(term){
    try {
      let params = new URLSearchParams({ term: term || '' });
      let url = `${this.endpoint}/search_donors`;
      let response = await this.get(url, params);
      return response.json.data || [];
    } catch {
      return [];
    }
  }

  async loadDonationForm(params){
    try{
      let url = `${this.endpoint}/load_donation_form`;
      let response = await this.get(url, params);
      return response.json.data;
    } catch {
      return null;
    }
  }

  async updateAbandonedDonations(params){
    // forward all donation_ids for this session to donationsController#update_failed_donations
    try {
      let url = `${this.endpoint}/failed`;
      await this.post(url, params);
    } catch {
      // Backend returns empty response - this is expected
    }
  }

  resendDonationReceipt(donationId) {
    try {
      let url = `${this.endpoint}/${donationId}/resend_receipt`;
      return this.get(url);
    }catch(e) {
      console.log('error resending receipt', donationId);
      return false;
    }
  }
  downloadDonationTemplate() {
    const url = `${this.endpoint}/export_model_template`;
    const fileName = `offline_gift_template.xlsx`;
    return super.downloadFile(url, fileName, 'text/csv');
  }
}
